
document.addEventListener('DOMContentLoaded', function () {
  const btnNext      = document.querySelector('.instructions--arrow');
  const trackText    = document.querySelector('.instructions--text-track');
  const slidesText   = document.querySelectorAll('.instructions--text-slide');
  let currentIndex   = 0;
  const totalSlides  = slidesText.length;

  btnNext.addEventListener('click', () => {
    // Désactive l’ancien slide
    slidesText[currentIndex].classList.remove('active');

    // Passe au suivant (boucle)
    currentIndex = (currentIndex + 1) % totalSlides;

    // Active le nouveau slide
    slidesText[currentIndex].classList.add('active');

    // Translate le track
    trackText.style.transform = `translateX(-${currentIndex * 100}%)`;
  });
});

